import React from 'react';

const SectionTitle = ({ children }) => (
  (children === 'PAKET TRAINING HAIRSTYLIST') ? (
    <h1 className="text-4xl font-bold text-center bg-gradient-to-r from-blue-600 to-purple-600 text-transparent bg-clip-text mt-20">
    {children}
  </h1>
  ) : (
    <h1 className="text-4xl font-bold text-center bg-gradient-to-r from-blue-600 to-purple-600 text-transparent bg-clip-text">
    {children}
      </h1>
    )
);

export default SectionTitle;